import React, { useEffect, useState } from 'react'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { DataGrid } from '@mui/x-data-grid';
import StudentTools from './StudentTools';
import StudentModel from './StudentModel';
import { StudentDelete, StudentShowdata } from '../../services/LoginPageService';
import { Tooltip } from '@mui/material';
import QrCodeIcon from '@mui/icons-material/QrCode';
import StudentQrcode from './StudentQrCode';
import NotificationBar from '../notification/ServiceNotificationBar';
import DeleteConfirmationDailog from '../../utils/confirmDeletion';

const StudentList = () => {
  const [rows,setRow]=useState([]);
  const [viewQrCode,setViewQrCode]= useState(false);
  const [isAddButton, setIsAddButton] = useState(true);
  const [editStudent, setEditStudent] = useState('');
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [dataForQR,setDataForQr]= useState('');
  const [refreshData, setRefreshData] = useState(false);
  const [isLoading, setGridLoading] = useState(true);
  const [deleteId,setDeleteId]=useState('');
  const [deleteDailogOpen,setDeleteDailogOpen]= useState(false);
  const [openNotification, setNotification] = useState({
    status: false,
    type: 'error',
    message: '',
  });
  
  const columns = [
    {
      field: 'studentId',
      headerClassName: 'super-app-theme--header',
      headerName: 'Campus Id',
      minWidth: 90, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'registrationNo',
      headerClassName: 'super-app-theme--header',
      headerName: 'Registration No',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'studentName',
      headerClassName: 'super-app-theme--header',
      headerName: 'Student Name',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'location',
      headerClassName: 'super-app-theme--header',
      headerName: 'Location',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'branch',
      headerClassName: 'super-app-theme--header',
      headerName: 'Hostel Name',
      minWidth: 90, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'specialization',
      headerClassName: 'super-app-theme--header',
      headerName: 'Specialization',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'semester',
      headerClassName: 'super-app-theme--header',
      headerName: 'Year',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    
    {
      field: 'gender',
      headerClassName: 'super-app-theme--header',
      headerName: 'Gender',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'studentContactNo',
      headerClassName: 'super-app-theme--header',
      headerName: 'Student Contact No',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'emailId',
      headerClassName: 'super-app-theme--header',
      headerName: 'Email Id',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'parentsNo',
      headerClassName: 'super-app-theme--header',
      headerName: 'Parents No',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'parentsEmailId',
      headerClassName: 'super-app-theme--header',
      headerName: 'Parents Email Id',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'altContactNo',
      headerClassName: 'super-app-theme--header',
      headerName: 'Alternate No',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'rfid',
      headerClassName: 'super-app-theme--header',
      headerName: 'RFID',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      headerClassName: 'super-app-theme--header',
      width: 100,
      cellClassName: 'actions',
      disableClickEventBubbling: true,
      getActions: (params) => [
        <EditData selectedRow={params.row} />, 
        <DeleteData selectedRow={params.row} />,
        
      ],
    },
  ];

  function EditData(props) {
    return (
      <Tooltip title="Edit">
        <EditIcon style={{cursor: 'pointer'}}
          onClick={(event) => {
            event.stopPropagation();
            setIsAddButton(false);
            setEditStudent(props.selectedRow);
            setOpen(true);
          }}
        />
      </Tooltip>
    );
  }

  function DeleteData(props) {
    return (
      <Tooltip title="Delete">
        <DeleteIcon style={{color:'#012738',cursor: 'pointer'}}
          onClick={() => {
          setDeleteId(props.selectedRow.id);
          console.log(props.selectedRow.id);
          setDeleteDailogOpen(true);
        }}
      />
      </Tooltip>
    );
  }

  const DeleteFunction =()=>{
    StudentDelete(handleDeleteSuccess,handleDeleteException);
  }

  const handleDeleteSuccess = (dataObject) =>{
    console.log(dataObject);
    setNotification({
      status: true,
      type: 'success',
      message: dataObject.message,
    }); 
    setTimeout(()=>{
      setDeleteDailogOpen(false);
    }, 2000); 
    setRefreshData(oldValue => !oldValue);
  }

  const handleDeleteException = (errorObject, message) =>{
    console.log(message);
    setNotification({
      status: true,
      type: 'error',
      message:message,
    });
  }
  
  useEffect(()=>{
    StudentShowdata(handleStudentShow,handeStudentException);
  },[refreshData]);
      
  const handleStudentShow=(dataObject)=>{
    setGridLoading(false);
    setRow(dataObject?.data || []);
  }

  const handeStudentException=(errorStatus, errorMessage)=>{
    console.log(errorMessage);
  }

  const handleClose = () => {
    setNotification({
      status: false,
      type: '',
      message: '',
    });
  };

  return (
    <div style={{ height:600 , width: '98%',marginLeft:'5px' ,marginTop:'10px',overflow: "scroll",marginRight:'10px' }}>
      <StudentTools
        setIsAddButton={setIsAddButton}
        editStudent={editStudent}
        setOpen={setOpen}
        setOpen2={setOpen2}
        setEditStudent={setEditStudent}   
      />

      <StudentModel
        isAddButton={isAddButton}
        editStudent={editStudent}
        setEditStudent={setEditStudent} 
        open={open}
        setOpen={setOpen}
        setRefreshData={setRefreshData}
        handleClose={handleClose}
        openNotification={openNotification}
        setNotification={setNotification}
      />

      <NotificationBar
        handleClose={handleClose}
        notificationContent={openNotification.message}
        openNotification={openNotification.status}
        type={openNotification.type}
      />

      <DeleteConfirmationDailog
        open={deleteDailogOpen}
        setOpen={setDeleteDailogOpen}
        deleteId={deleteId}
        deleteService={StudentDelete}
        handleSuccess={handleDeleteSuccess}
        handleException={handleDeleteException}
      />

      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={10}
        loading={isLoading} 
        rowsPerPageOptions={[8]}
        disableSelectionOnClick
        sx={{
          height: '480px',
          width: '100%',
          '& .super-app-theme--header': {
            WebkitTextStrokeWidth:'0.6px',
          },
        }}
      />
    </div>
  )
}

export default StudentList
